/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {PkceTokenRequest, PkceTokenRequestInterface} from '@/services/pkce/types';
import {userSessionModule} from '@/store/modules/user-session';
import pkce from '@/services/pkce';

const namespace: string = 'userSessionModule';

/**
 * Authentication (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-authenticate',
    components: {},
})
export default class Authenticate extends Vue {
    @Action('authenticate', {namespace}) public authenticate: any;
    @Action('decode', {namespace}) public decode: any;
    @Action('logout', {namespace}) public logout: any;
    @Getter('verifier', {namespace}) public verifier!: string;
    @Getter('getCurrentView', {namespace}) public getCurrentView!: {name: string, param?: any} | undefined;
    @Prop(String) public code!: string;

    /**
     * Mounted life-cycle event.
     */
    public mounted(): void {
        // ensure the user is logged out
        this.logout();

        // authenticate the steam user token
        this.authenticateUser();
    }

    /**
     * Authenticate (oauth) user.
     *
     * @returns {Promise<void>}
     */
    private async authenticateUser(): Promise<void> {
        try {
            const request: PkceTokenRequestInterface = new PkceTokenRequest(
                this.code,
                this.verifier,
                process.env.VUE_APP_CLIENTID || '',
                pkce.redirectUrl,
            );

            await this.authenticate(request);
            await this.decode();
        } catch (error) {
            // could not log in - redirect to home
        } finally {
            const view: any = undefined !== this.getCurrentView ? this.getCurrentView : 'home';
            this.$router.push(view);
            // old code - to delete if the above works correctly
            // this.$router.push({name: 'home'});
        }
    }
}
